/* Backorder acknowledgement gate — load as a theme asset (assets/backorder-gate.js)
   Works with the markup from the "backorder-acknowledgement-block.liquid" Custom Liquid block.
   Does NOTHING on pages without that block, so normal products are unaffected. */
(function () {
  function start() {
    if (window.__backorderGate) { window.__backorderGate.assert(); return; }
    if (!document.querySelector('[data-backorder-ack]')) return; // no gate on this page
    install();
  }

  function install() {
    // Containers we must NOT touch (related-product cards / quick-add widgets).
    var SKIP = '.card, .card-wrapper, .product-card, .grid-product, quick-add-modal, quick-add, .quick-add, [id^="QuickAdd"], [id^="quick-add"]';

    var gateOpen = false;
    var ackValue = '';

    function inSkip(el) { return el && el.closest && el.closest(SKIP); }

    function addButtons() {
      return Array.prototype.filter.call(
        document.querySelectorAll('[name="add"]'),
        function (b) { return !inSkip(b); }
      );
    }
    function cartForms() {
      return Array.prototype.filter.call(
        document.querySelectorAll('form[action*="/cart/add"], form[action$="/cart"]'),
        function (f) { return !inSkip(f); }
      );
    }
    function dynamicButtons() {
      return Array.prototype.filter.call(
        document.querySelectorAll('.shopify-payment-button'),
        function (d) { return !inSkip(d); }
      );
    }

    function ensureProp(form) {
      var p = form.querySelector('input[data-backorder-prop]');
      if (!p) {
        p = document.createElement('input');
        p.type = 'hidden';
        p.name = 'properties[Backorder acknowledgement]';
        p.setAttribute('data-backorder-prop', '');
        form.appendChild(p);
      }
      p.value = ackValue;
    }

    function assert() {
      cartForms().forEach(ensureProp);
      addButtons().forEach(function (b) {
        if (gateOpen) {
          if (b.hasAttribute('data-bo-gated')) { b.disabled = false; b.removeAttribute('data-bo-gated'); }
        } else {
          b.disabled = true; b.setAttribute('data-bo-gated', '');
        }
      });
      dynamicButtons().forEach(function (d) { d.style.display = gateOpen ? '' : 'none'; });
    }

    function flashError() {
      document.querySelectorAll('[data-backorder-ack]').forEach(function (w) { w.setAttribute('data-error', ''); });
      var box = document.querySelector('[data-backorder-checkbox]');
      if (box) { try { box.focus(); } catch (e) {} box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    function setGate(open) {
      gateOpen = open;
      if (open) {
        if (!ackValue) ackValue = 'Acknowledged ' + new Date().toISOString();
        document.querySelectorAll('[data-backorder-ack]').forEach(function (w) { w.removeAttribute('data-error'); });
      } else {
        ackValue = '';
      }
      document.querySelectorAll('[data-backorder-checkbox]').forEach(function (b) { b.checked = open; });
      assert();
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-backorder-checkbox]')) {
        setGate(!!e.target.checked);
      }
    });

    function stop(e) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      e.stopPropagation();
    }
    function block(e) {
      if (gateOpen) return;
      if (e.type === 'submit') {
        if (cartForms().indexOf(e.target) !== -1) { stop(e); flashError(); }
        return;
      }
      var btn = e.target && e.target.closest && e.target.closest('[name="add"]');
      if (btn && !inSkip(btn)) { stop(e); flashError(); }
    }
    document.addEventListener('click', block, true);
    document.addEventListener('submit', block, true);

    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; assert(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.__backorderGate = { assert: assert };

    setGate(false);
    [150, 600, 1500].forEach(function (t) { setTimeout(assert, t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  [800, 2000].forEach(function (t) { setTimeout(start, t); }); // catch late-injected blocks
})();